import React from 'react';
import ReactDOM from 'react-dom';
import App, { AppProps } from './components/App';
import { clearCache, queryClientGlobal } from './components/queryClientGlobal';
import { userManagementClient } from './components/userManagementClient';

export { unmountComponentAtNode } from 'react-dom';

export const insertIntoNode = (
  { path, data, params }: Omit<AppProps, 'queryClient'>,
  node: Element,
) => {
  ReactDOM.render(
    <App
      queryClient={queryClientGlobal}
      userManagementClient={userManagementClient}
      path={path}
      data={data}
      params={params}
    />,
    node,
  );
};

export const clearReactQueryCache = () => clearCache();

export { isAvailableFromDevToPreProd, isDevOrSandboxOrStaging } from './config/isAvailableOn';

export { getPaymentMethodType, setLastPaymentProviderUpdate } from './Session';

export * from './capacities';
